export enum CHANNEL {
    ALL = 'ALL',
    DISPLAY = 'DISPLAY',
    VIDEO = 'VIDEO',
    SOCIAL = 'SOCIAL',
    CONNECTED_TV = 'CONNECTED_TV',
    LINEAR_TV = 'LINEAR_TV',
    INAPP = 'INAPP',
    CONVERSATIONAL_AI = 'CONVERSATIONAL_AI',
}
